import React, { useContext } from "react";
import { UserContext } from "./UserProvider";

const NoReceptionNoMeetingWelcome = ({ companyProfile }) => {
  const { fullName } = useContext(UserContext);

  return (
    <div style={{ padding: "3rem" }}>
      {companyProfile && (
        <div className="row">
          <div style={{ paddingRight: "1rem" }}>
            <img
              src="/img/no-reception-person.png"
              className="rounded-lg bg-light"
              width="100"
              height="100"
              alt={companyProfile.CompanyName}
            />
          </div>
          <div className="col">
            <div className="card welcome-card">
              <div className="card-body">
                <h6 className="welcome-card-text">Hi {fullName},</h6>
                <h6 className="welcome-card-text">
                  Welcome to the {companyProfile.CompanyName} Meeting Suite.
                  Unfortunately, our Reception is now closed. Please refer to
                  our list of delegates attending {companyProfile.EventName} and
                  feel free to contact them directly.
                </h6>
                <h6 className="welcome-card-text">
                  Thank you for stopping by!
                </h6>
                <br />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoReceptionNoMeetingWelcome;
